import { memo, useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BzTab, BzTabs, BzToolTip } from '../../components';
import { clearLoginQRInterval, getAppInfoData, getDecryptLocalStorage, getStorageWithMultiTabCheck, setEncryptLocalStorage,getStorageWithMultiTabCheckWithoutEncryption } from '../../utils/global_functions';
import { resetAllAuthData, userGenerateQR } from '../../redux/actions/auth';
import { useDispatch, useSelector } from 'react-redux';
import useAnalyticsEventTracker from '../../hooks/useAnalyticsEventTracker';
import { APP_INFO_PARAMS, LOCAL_STORAGE_KEYS } from '../../utils/global_variables';

const Header = (props) => {

    const { bMpinEnabled, mpinlogin, activeProfile, objLoginSession, setUsersModal, inputRef, passwordRef, setLoginTab } = props;
    const [bQRLogin, setbQRLogin] = useState(false);
    const previousLoginTab = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.LOGIN_TAB);
    const [tabKey, setTabKey] = useState(previousLoginTab || 'mpin');
    const dispatch = useDispatch();
    const isPasswordChanged = getDecryptLocalStorage('IS_PASSWORD_CHANGED');
    let activeUser = getStorageWithMultiTabCheckWithoutEncryption('ACTIVE_USER');
    const isSwitchUserDisabled = localStorage.getItem(LOCAL_STORAGE_KEYS.DISABLE_SWITCH_USER);





    const handleLoginQr = () => {
        setLoginTab('qr_code')
    }

    const getEvent = useAnalyticsEventTracker('LOGIN');
    /*Mahesh S  : 28-04-2023 : BT-101870 -  Breeze - Breeze Login Through QR Code - Start */
    const handleQRLogin = () => {//onClick of QR code tab dispatching generate QR API and reseting allauthdata
        handleTabChange('qr_code');
        dispatch(userGenerateQR());
        getEvent("LOGIN_QRCode");
        dispatch(resetAllAuthData());
        setbQRLogin(true);
    };
    /*Mahesh S  : 28-04-2023 : BT-101870 -  Breeze - Breeze Login Through QR Code - end */

    const handleTabChange = (value) => {
        setEncryptLocalStorage(LOCAL_STORAGE_KEYS.LOGIN_TAB, value);
        setTabKey(value);
    };

    /*Mahesh S  : 02-05-2023 : BT-101870 -  Breeze - Breeze Login Through QR Code - Start */
    const handleMpinTab = () => {
        handleTabChange('mpin');
        getEvent("LOGIN_MPIN");
        dispatch(resetAllAuthData());
        clearLoginQRInterval();
        inputRef?.current?.focus();
        setbQRLogin(false);
    };

    const handlePasswordTab = () => {
        handleTabChange('pswd');
        getEvent("LOGIN_PASSWORD");
        dispatch(resetAllAuthData());
        clearLoginQRInterval();
        passwordRef?.current?.focus();
        setbQRLogin(false);
    };
    /*Mahesh S  : 02-05-2023 : BT-101870 -  Breeze - Breeze Login Through QR Code - End */

    const shortName = activeProfile?.userName?.split(/\s/)?.reduce((resp, word) => resp += word?.slice(0, 1), '')?.substr(0, 2)?.toUpperCase();  // Acronym will display if image not found

    const profilePic = getStorageWithMultiTabCheck(`${LOCAL_STORAGE_KEYS.PROFILE_PICTURE}_${activeProfile?.userId}`);

    const handleUserIdTab = () => {
        setLoginTab('user_id')
        dispatch(resetAllAuthData());
        clearLoginQRInterval();
    };

    // {/* Mahesh S : 09-11-2023 : BT-97226 Subsequent Login – Profile pic changes – Start */ }
    const handleUsersModal = () => {
        setUsersModal(true);
    };
    // {/* Mahesh S : 09-11-2023 : BT-97226 Subsequent Login – Profile pic changes – Start */ }

    useEffect(() => {
        if (isPasswordChanged) {
            handleTabChange('pswd');
        }
    }, [isPasswordChanged]);



    return (
        <>

            <Container fluid className='p-0'>
                <Row className='g-0'>
                    <Col className='d-flex align-items-center justify-content-start'>
                        <div className='logo-container'>
                            <div data-testid='header-logo' className='logo img-fluid'></div>
                        </div>
                    </Col>
                </Row>
                <Row className='g-0'>
                    {bMpinEnabled && mpinlogin === 'true' ?
                        <>
                            {!bQRLogin ?
                                <Row className='g-0 mb-2'>
                                    <Col md={5} xl={7} className='d-flex justify-content-start align-items-center'>
                                        <BzToolTip placement='bottom' TooltipMsg={activeProfile?.userName} >
                                            <div className='font-medium font-size4 color-text'>Hi <span className='text-uppercase' title={activeProfile?.userName}>{activeProfile?.userName?.length > 30 ? activeProfile?.userName?.slice(0, 15) + ".." : activeProfile?.userName}</span></div>
                                        </BzToolTip>
                                    </Col>
                                    {
                                        !isSwitchUserDisabled ? <Col md={7} xl={5} className='d-flex justify-content-end align-items-center'>
                                            <div className='login-user-wrap d-flex flex-row justify-content-between align-items-center'>
                                                <div className='userimg'>
                                                    {profilePic ?
                                                        <img className='rounded-circle' src={profilePic} alt={objLoginSession?.data?.user_name} /> :
                                                        <div className='profile-picture-name'>{shortName}</div>
                                                    }
                                                </div>
                                                <div className='font-medium font-size2 color-subtext'>User ID: <span className='font-medium font-size1 color-text'>{activeUser}</span></div>                                                
                                                <div data-testid='relogin-initiate-switch-user-icon' className='icon-12 icon-arrowdown icon-dark flex-shrink-0 me-1' onClick={handleUsersModal}></div>                                                
                                            </div>
                                        </Col> : null
                                    }

                                </Row>
                                :
                                <Row className='g-0 mb-2'>
                                    <Col className='d-flex align-items-center'>
                                        <div className='font-medium font-size10 color-text'>Login with</div>
                                    </Col>
                                </Row>
                            }

                            <Row className='g-0'>
                                <div className='horizontal-scroll-wrap'>
                                    <BzTabs className='nav nav-tabs'>
                                        <BzTab data-testid='relogin-mpin-tab' onClick={handleMpinTab} className='nav-link text-capitalize' tabindex={null} isActive={tabKey === 'mpin'} tabKey='mpin'>M-PIN</BzTab>
                                        <BzTab data-testid='relogin-password-tab' onClick={handlePasswordTab} className='nav-link text-capitalize px-5' tabindex={null} isActive={tabKey === 'pswd'} tabKey='pswd'>Password</BzTab>
                                        <BzTab data-testid='relogin-qr-tab' onClick={handleQRLogin} className='nav-link text-capitalize' tabKey='qr_code' tabindex={null} isActive={tabKey === 'qr_code'}  >QR Code</BzTab>
                                    </BzTabs>
                                </div>
                            </Row>
                        </> :
                        <>
                            <Row className='g-0 mb-2'>
                                <Col>
                                    <div className='font-medium font-size10 color-text'>Login with</div>
                                </Col>
                            </Row>
                            <Row className='g-0'>
                                <div className='horizontal-scroll-wrap'>
                                    <BzTabs className='nav nav-tabs'>
                                        <BzTab data-testid='first-login-id-password-tab' onClick={handleUserIdTab} className='nav-link text-capitalize' isActive tabKey='user_id'>User ID</BzTab>
                                        <BzTab data-testid='first-login-qr-code-tab' onClick={handleLoginQr} className='nav-link text-capitalize' tabKey='qr_code'>QR Code</BzTab>
                                    </BzTabs>
                                </div>
                            </Row>
                        </>
                    }
                </Row>
            </Container>

        </>
    );
};
export default memo(Header);